import {useState} from 'react';
import {DialogTrigger, Root as DialogRoot} from '@radix-ui/react-dialog';

import {Address} from '#apollo/schema';
import {Icon, Modal, Text} from '#component/base';

import {
  innerContentEditText,
  innerContentEditTrigger,
  innerContentEditWrapper,
  innerContentHeading,
  innerContentHeadingText,
} from '../../InfoBoxes.css';
import {infoBox, innerContent, innerContentText} from '../../InfoBoxes.css';
import FormEditShipping from './FormEditShipping';
import {parseShippingAddress} from './ShippingAddressBox.util';

type ShippingAddressBoxProps = {
  firstName: string | undefined;
  lastName: string | undefined;
  shippingAddress: Address;
};

const ShippingAddressBox = ({firstName, lastName, shippingAddress}: ShippingAddressBoxProps) => {
  const [open, setOpen] = useState(false);

  const shippingAddressFields = parseShippingAddress(
    firstName ?? '',
    lastName ?? '',
    shippingAddress,
  );

  return (
    <div className={infoBox}>
      <div className={innerContentHeading}>
        <Text as="h3" variant="body" className={innerContentHeadingText}>
          Shipping Address
        </Text>
        <div className={innerContentEditWrapper}>
          <DialogRoot open={open} onOpenChange={setOpen}>
            <DialogTrigger onClick={() => {}} className={innerContentEditTrigger}>
              <Text as="p" variant="body" className={innerContentEditText}>
                Edit
              </Text>
              <Icon
                name="PencilSimple"
                size="small"
                color="burgundy"
                className={innerContentEditText}
              />
            </DialogTrigger>
            <Modal
              header={
                <Text color="inherit" variant="heading3">
                  Edit Shipping Address
                </Text>
              }>
              <FormEditShipping
                handleCancel={() => setOpen(false)}
                submitCallback={() => {}}
                shippingAddress={shippingAddressFields}
              />
            </Modal>
          </DialogRoot>
        </div>
      </div>
      <div className={innerContent}>
        <Text as="h3" variant="body" className={innerContentText}>
          {shippingAddressFields.firstName} {shippingAddressFields.lastName}
        </Text>
        <Text as="p" variant="body" className={innerContentText}>
          {shippingAddressFields.address} {shippingAddressFields.addressDetail}
        </Text>
        <Text as="p" variant="body" className={innerContentText}>
          {`${shippingAddressFields.city} ${shippingAddressFields.state} ${shippingAddressFields.postalCode}`}
        </Text>
      </div>
    </div>
  );
};

export default ShippingAddressBox;
